// deno-lint-ignore-file no-window-prefix no-window
/** @jsx h */
/** @jsxFrag Fragment */
import { h } from "preact";
import { useRef, useState } from "preact/hooks";

import { DatUIBaseProps } from "./dat.tsx";
import { clamp, cx, toNumber } from "@utils/utils";
import { Interactive } from "@uiw/utils";

export interface SliderProps extends DatUIBaseProps {
  min?: number;
  max?: number;
  width: number;
  value: number;
  onChange: (value: number) => void;
}
export function Slider(props: SliderProps) {
  const sliderRef = useRef<any>();
  const [state, setState] = useState({ value: props.value });

  const { width, style } = props;
  const min = props.min || 0;
  const max = props.max || 0;
  const { value } = state;
  const widthBackground = clamp(((value - min) * 100) / (max - min), 0, 100);
  const sliderStyles = {
    width: `${width}%`,
    backgroundSize: `${widthBackground}% 100%`,
    ...style,
  };

  const update = (pageX: number, isLive = true) => {
    const rect = sliderRef.current.getBoundingClientRect();
    const x = pageX - rect.left;
    const w = rect.right - rect.left;
    const value = min + clamp(x / w, 0, 1) * (max - min);

    setState({ value });
    if (props.onChange) props.onChange(value);
  };

  const handleMouseMove = (event: MouseEvent) => {
    event.preventDefault();
    update(event.pageX);
  };

  const handleMouseUp = (event: MouseEvent) => {
    update(event.pageX, false);

    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };

  const onMouseDown = (event: MouseEvent) => {
    update(event.pageX);

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  const onClick = (event: any) => {
    // do not focus input field on slider click
    event.preventDefault();
  };

  return (
    <span
      ref={sliderRef}
      class={cx("slider", props.class)}
      style={sliderStyles}
      onClick={onClick}
      onMouseDown={onMouseDown}
      role="slider"
      tabIndex={0}
      aria-valuenow={value}
      aria-valuemin={min}
      aria-valuemax={max}
    />
  );
}

export interface DatNumberProps extends DatUIBaseProps {
  onChange: (value: number) => void;
  class?: string;
  style?: any;
  value: number;
  min: number;
  max: number;
  step?: number;
  label?: string;
  labelWidth?: string;
  disableSlider?: boolean;
}

export function DatNumber(props: DatNumberProps) {
  const labelWidth = "40%";
  const labelText = props.label || "DefaultLabel";
  const hasSlider = true;
  const disableSlider: boolean = false as boolean;
  const controlsWidth = 100;

  const inputWidth = hasSlider && disableSlider !== true
    ? Math.round(controlsWidth / 3)
    : controlsWidth;

  const sliderWidth = controlsWidth - inputWidth;

  const widthBackground = clamp(
    ((props.value - props.min) * 100) / (props.max - props.min),
    0,
    100,
  );
  const sliderStyles = {
    width: `${sliderWidth}%`,
    height: `var(--number-height)`,
    backgroundSize: `${widthBackground}% 100%`,
  };

  return (
    <li class={cx("cr", "number", props.class)} style={props.style}>
      <label>
        <span class="label-text" style={{ width: labelWidth }}>
          {labelText}
        </span>
        <span style={{ display: "inherit", width: `calc(100% - ${labelWidth})` }}>
          {hasSlider && disableSlider !== true
            ? (
              // <Interactive
              //   class={"slider"}
              //   style={sliderStyles}
              //   onMove={(v) => {
              //     const x = v.left;
              //     const value = props.min + clamp(x / sliderWidth, 0, 1) * (props.max - props.min);
              //     console.log(value)
              //     props.onChange(value);
              //   }}
              //   onKey={(v) => {
              //     const x = v.left;
              //     const value = props.min + clamp(x / sliderWidth, 0, 1) * (props.max - props.min);
              //     console.log(value)

              //     props.onChange(value);
              //   }}
              // ></Interactive>
              <Slider
                value={props.value}
                min={props.min}
                max={props.max}
                width={sliderWidth}
                onChange={(value) => props.onChange(value)}
              />
            )
            : null}
          <input
            type="number"
            step={props.step}
            min={props.min}
            max={props.max}
            inputMode="numeric"
            value={props.value}
            style={{ width: `${inputWidth}%` }}
            onChange={(e) => {
              props.onChange(toNumber((e.target! as any).value));
            }}
          />
        </span>
      </label>
    </li>
  );
}
